export default "__VITE_ASSET__DFXSHOzF__"